import { gamutServiceAxios } from "./config/createAxiosInstance";

export const gamutChartAPI = {
  checkGamutGraphService: async function (payload) {
    const response = await gamutServiceAxios.request({
      url: `/check-gamut`,
      method: "POST",
      headers: {
        authorization: `Bearer ${localStorage.getItem("avEcoAccessToken")}`,
      },
      data: payload
    });
    return response.data;
  }
};
